var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container mt-4" },
    [
      _c(
        "div",
        { staticClass: "row justify-content-center align-items-end" },
        [
          _vm.telestrokeMode && !_vm.asapTabVisible
            ? _c("hospital-filter", { staticClass: "mr-4" })
            : _vm._e(),
          _vm._v(" "),
          _vm.asapTabVisible
            ? _c("asap-sites-filter", { staticClass: "mb-0 mr-4" })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mr-2" },
            [
              _c("label", { staticClass: "mb-0" }, [
                _vm._v("\n                Start\n            ")
              ]),
              _vm._v(" "),
              _c("date-time-picker", {
                staticClass: "w-100",
                attrs: {
                  monthPicker: "",
                  placeholder: "Select start month",
                  config: { altFormat: "M Y", dateFormat: "Y-m" }
                },
                model: {
                  value: _vm.startDate,
                  callback: function($$v) {
                    _vm.startDate = $$v
                  },
                  expression: "startDate"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mr-2" },
            [
              _c("label", { staticClass: "mb-0" }, [
                _vm._v("\n                End \n                "),
                _c(
                  "span",
                  { attrs: { title: "(includes the provided month)" } },
                  [
                    _c("fnt-a-icon", {
                      staticClass: "r-clickable",
                      attrs: { icon: ["fal", "info-circle"] }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("date-time-picker", {
                staticClass: "w-100",
                attrs: {
                  monthPicker: "",
                  placeholder: "Select end month",
                  config: { altFormat: "M Y", dateFormat: "Y-m" }
                },
                model: {
                  value: _vm.endDate,
                  callback: function($$v) {
                    _vm.endDate = $$v
                  },
                  expression: "endDate"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            { staticClass: "mb-0" },
            [
              _c("label", { staticClass: "mb-0" }, [_vm._v("Quick select")]),
              _vm._v(" "),
              _c(
                "b-dd",
                { staticClass: "d-block", attrs: { text: "by year" } },
                _vm._l(_vm.years, function(item) {
                  return _c(
                    "b-dd-item",
                    {
                      key: item.value,
                      on: {
                        click: function($event) {
                          return _vm.setYearRange(item.value)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(item.title) +
                          "\n                "
                      )
                    ]
                  )
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            { staticClass: "mb-0 ml-1" },
            [
              _c(
                "b-dd",
                { attrs: { text: "by month" } },
                _vm._l(_vm.months, function(item) {
                  return _c(
                    "b-dd-item",
                    {
                      key: item.value,
                      on: {
                        click: function($event) {
                          return _vm.setMonthRange(item.value)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(item.title) +
                          "\n                "
                      )
                    ]
                  )
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("b-form-group", { staticClass: "mb-0 ml-1" }, [
            _c("label", { staticClass: "mb-0" }, [_vm._v("Shift")]),
            _vm._v(" "),
            _c("div", { staticClass: "input-group" }, [
              _c(
                "div",
                { staticClass: "input-group-prepend" },
                [
                  _c(
                    "b-btn",
                    {
                      attrs: { title: "year" },
                      on: {
                        click: function($event) {
                          return _vm.shiftByMonths(-12)
                        }
                      }
                    },
                    [
                      _c("fnt-a-icon", {
                        attrs: { icon: ["fas", "chevron-double-left"] }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-btn",
                    {
                      attrs: { title: "month" },
                      on: {
                        click: function($event) {
                          return _vm.shiftByMonths(-1)
                        }
                      }
                    },
                    [
                      _c("fnt-a-icon", {
                        attrs: { icon: ["fas", "chevron-left"] }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-btn",
                    {
                      attrs: { title: "month" },
                      on: {
                        click: function($event) {
                          return _vm.shiftByMonths(1)
                        }
                      }
                    },
                    [
                      _c("fnt-a-icon", {
                        attrs: { icon: ["fas", "chevron-right"] }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-btn",
                    {
                      attrs: { title: "year" },
                      on: {
                        click: function($event) {
                          return _vm.shiftByMonths(12)
                        }
                      }
                    },
                    [
                      _c("fnt-a-icon", {
                        attrs: { icon: ["fas", "chevron-double-right"] }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-tabs",
        {
          ref: "tabs",
          staticClass: "mt-4",
          attrs: { justified: "", "content-class": "mt-4" },
          model: {
            value: _vm.activeTab,
            callback: function($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab"
          }
        },
        [
          _c(
            "b-tab",
            { attrs: { title: "Charts", lazy: "" } },
            [
              _c("stroke-charts", { attrs: { start: _vm.start, end: _vm.end } })
            ],
            1
          ),
          _vm._v(" "),
          _vm.showAsapUsage
            ? _c(
                "b-tab",
                { attrs: { title: "ASAP Usage", lazy: "" } },
                [
                  _c("asap-usage", {
                    attrs: { start: _vm.start, end: _vm.end }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }